/**
 * First-refresh bootstrap helpers. The combined GraphQL query fills the store;
 * these flags skip the immediate follow-up of the original per-page APIs.
 */

let primedCourseId = null;

/**
 * Remembers which course the first-load payload already applied.
 *
 * @param {string|null} courseId Course identifier from the current URL.
 * @returns {void}
 */
export const markFirstLoadPrimed = (courseId) => {
  primedCourseId = courseId || null;
};

/**
 * True when first-load already applied this course and the original detail
 * query should not run again for this page.
 *
 * @param {string} courseId Course identifier.
 * @returns {boolean}
 */
export const isPrimedCourse = (courseId) => Boolean(primedCourseId && courseId && primedCourseId === courseId);

/**
 * Reads the open course (and unit indexes) from a router or window path.
 *
 * @param {string} [pathname] Pathname, optionally with search/hash.
 * @returns {{ courseId: string|null, routerUrl: string|null }}
 */
export const parseAppPath = (pathname) => {
  const path = String(pathname || "");
  const content = path.match(/\/(?:content|preview)\/([^/?#]+)\/(\d+)\/(\d+)\/(\d+)/);
  if (content) {
    return {
      courseId: decodeURIComponent(content[1]),
      routerUrl: `${content[2]}/${content[3]}/${content[4]}`,
    };
  }
  const course = path.match(/\/(?:course|analysis|guide)\/([^/?#]+)/);
  if (course) return { courseId: decodeURIComponent(course[1]), routerUrl: null };
  return { courseId: null, routerUrl: null };
};
